export enum Appearance {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  NEUTRAL = 'neutral',
  DANGER = 'danger',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export enum Size {
  SMALLEST = 'smallest',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  LARGEST = 'largest',
}

export enum FontWeight {
  REGULAR = 400,
  MEDIUM = 500,
  SEMI_BOLD = 600,
  BOLD = 700,
}

export enum Align {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  JUSTIFY = 'justify',
  START = 'start',
  END = 'end',
}
